export default __webpack_public_path__ + "static/media/element_71.577bd103.jpg";